import importCity from './components/wizard.vue';

export default {
  routes: [
    {
      path: '/',
      component:importCity,
      name:'importCity'
    },
  ]
};
